import { createBrowserRouter, Navigate, defer } from "react-router-dom";
import ErrorBoundary from "@/layout/ErrorBoundary";
import RootLayout from "@/layout/RootLayout";
import SecurityLayout, { initAuthentication } from "@/layout/SecurityLayout";
import { lazy } from "react";
import { getDebugModeRouteConfig } from "./dev";
import transferRoutes from "./transfer";
import addressRoutes from "./address";

const Page403 = lazy(() => import("@/pages/error/403"));

const Page404 = lazy(() => import("@/pages/error/404"));

const TestUI = lazy(() => import("@/pages/dev/TestUI"));

const routes = createBrowserRouter([
  {
    path: "/",
    element: <RootLayout />,
    errorElement: <ErrorBoundary />,
    children: [
      {
        path: "/error/403",
        element: <Page403 />,
      },
      {
        path: "/error/404",
        element: <Page404 />,
      },
      { path: "/test", element: <TestUI /> },
      {
        element: <SecurityLayout />,
        loader: ({ request }) =>
          defer({ initAuthentication: initAuthentication(request) }),
        children: [...transferRoutes, ...addressRoutes],
      },
    ],
  },
  ...getDebugModeRouteConfig(),
  {
    path: "*",
    element: <Navigate to="/error/404" replace />,
  },
]);

export default routes;
